import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('politiekdirect_user');
    if (saved) {
      try {
        setUser(JSON.parse(saved));
      } catch (e) {}
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const response = await fetch('https://victor-web.leerheld.workers.dev/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, service: 'politiekdirect' })
    });
    
    if (response.ok) {
      const userData = await response.json();
      setUser(userData);
      localStorage.setItem('politiekdirect_user', JSON.stringify(userData));
      return { success: true };
    }
    return { success: false, error: 'Inloggen mislukt' };
  };

  const register = async (name, email, password) => {
    const response = await fetch('https://victor-web.leerheld.workers.dev/auth/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, password, service: 'politiekdirect' })
    });
    
    if (response.ok) {
      const userData = await response.json();
      setUser(userData);
      localStorage.setItem('politiekdirect_user', JSON.stringify(userData));
      return { success: true };
    }
    return { success: false, error: 'Registratie mislukt' };
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('politiekdirect_user');
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center">Laden...</div>;

  return (
    <AuthContext.Provider value={{ user, login, register, logout, isAuthenticated: !!user, isAdmin: user?.role === 'admin' }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
